module.exports = __webpack_public_path__ + "logo_gengji2.png?9957db6a884ab7a389f8c3e457f1e12a";